<template>
    <div class="Department" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>部门管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="部门名称">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddDepartment">新增</el-button>
                        <!-- <el-button type="primary" @click="DepartmentCardShow">门禁卡列表</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="cCode" label="部门编码">
                    </el-table-column>
                    <el-table-column prop="title" label="部门名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditDepartment(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelDepartment(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Department" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Department">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="部门编码" prop="cCode">
                            <el-input v-model="form.cCode"></el-input>
                        </el-form-item>
                        <el-form-item label="部门名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="Department = false">取 消</el-button>
                        <el-button type="primary" @click="SaveDepartment" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "Department",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            Department: false,
            form: {
                title: '',
                cCode: '',
                remark: ''
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                keyword: ''
            },
            rules: {
                cCode: [
                    { required: true, message: '请输入部门编码', trigger: 'blur' }
                ],
                title: [
                    { required: true, message: '请输入部门名称', trigger: 'blur' }
                ]
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            confirmloding: false,
            DepartmentCardShowDialog: false,
            DepartmentCardList: []
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddDepartment () {
            this.Department = true
            this.title = '新增部门'
            this.form = {
                title: '',
                cCode: '',
                remark: ''
            }
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetDepartmentList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetDepartmentList()
        },
        GetDepartmentList () {
            let data = {
                keyword: this.queryform.keyword,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('DepartmentListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                console.log(res.data)
                this.tableData = res.data
                this.form = {
                    title: '',
                    cCode: '',
                    remark: ''
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                keyword: ''
            }
        },
        ConfirmQuery() {
            this.GetDepartmentList(this.queryform.keyword, this.queryform.room)
        },
        SaveDepartment() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            let True = true
            if (this.title != '编辑部门') {
                for (let item in this.tableData) {
                    if (this.tableData[item].cCode == data.cCode) {
                        True = false
                        break
                    }
                }
            }
            if (True) {
                // data.img = JSON.stringify(this.form.img)
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.confirmloding = true
                        that.$store.dispatch('SaveDepartment', data).then(res => {
                            that.confirmloding = false
                            if (res.flag) {
                                that.$message({
                                    message: '保存成功',
                                    type: 'success'
                                })
                                that.Department = false
                                that.fullscreenLoading = true
                                that.GetDepartmentList()
                            } else {
                                that.$message({
                                    message: res.message,
                                    type: 'warning'
                                })
                            }
                        })
                    } else {
                        // that.$message({
                        //     message: '请先填写必填项',
                        //     type: 'error'
                        // })
                        return false;
                    }
                });
            } else {
                that.$message({
                    message: '部门编码不能重复',
                    type: 'warning'
                })
            }
            
        },
        EditDepartment(row) {
            this.Department = true
            this.title = '编辑部门'
            this.form = JSON.parse(JSON.stringify(row))
            // this.fileList = JSON.parse(this.form.img)
            // this.form.img = JSON.parse(this.form.img)
        },
        DelDepartment(row) {
            this.$confirm('是否删除该部门？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelDepartment', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetDepartmentList(this.queryform.keyword, this.queryform.room)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        GetDepartmentCardList() {
            let data = {
                userid: getAdminId(),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('DepartmentCardListShow', data).then(res => {
                // this.fullscreenLoading = false
                // this.total = res.something
                console.log(res.data)
                // this.tableData = res.data
            })
        },
        DepartmentCardShow () {
            this.DepartmentCardShowDialog = true
            this.GetDepartmentCardList()
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetDepartmentList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.Department {
    width: 100%;
}
.Department .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.Department .el-header .el-row .el-col h2 {
    text-align: center;
}
.Department .el-header .el-row .el-col {
    text-align: center;
}
.Department .el-header .el-row .el-col:last-child {
    text-align: right;
}
.Department .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.Department .el-main .Department .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
/* .Department .el-main .Department .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
} */
</style>
